<template>
  <div style="margin: 16px; display: flex; justify-content: center;">
    <el-card
      shadow="hover"
      style="padding: 0 16px 16px 16px; width: 100%; max-width: 40em; min-height: 15em;"
    >
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <el-page-header
          @back="back"
          :content="event ? `${event.event_type.name} - ${event.date}` :'Loading...'"
        ></el-page-header>
      </div>
      <el-row v-loading="!event" class="flex">
        <div v-if="event" class="mg info">
          <div class="flex">
            <span class="mgra sub-header">Name</span>
            <span>{{ event.name }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">Date</span>
            <span>{{ event.date }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">Term</span>
            <span>{{ event.term.name }}</span>
          </div>
        </div>
      </el-row>
      <el-row v-if="event" class="flex between">
        <el-button v-if="$store.getters.hasPermission(['Records'])" @click="openEdit" type="primary">Edit</el-button>
        <el-button v-if="$store.getters.hasPermission(['EventScanning', 'Records'])" @click="openScanning" icon="el-icon-barcode">Scanning</el-button>
        <el-button v-if="$store.getters.hasPermission(['Records'])" @click="openAttendance" icon="el-icon-date">Attendance</el-button>
        <el-button v-if="$store.getters.hasPermission(['Records'])" @click="openObjectives" icon="el-icon-connection">Objectives</el-button>
      </el-row>
    </el-card>
    <nxs-attendance-management
      ref="attendanceDialog"
      attendance="event.attendance_records"
      :eventId="eventId"
    />
    <nxs-objective-link-management ref="objectiveDialog" :eventId="eventId" />
    <nxs-event-edit ref="editDialog" v-model="event" @save="eventSaved" />
    <nxs-event-scanning ref="scanningDialog" v-model="event"/>
  </div>
</template>

<style scoped>
.info {
  max-width: 20em;
  width: 100%;
  margin: 2em;
}
.between {
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
import nxsObjectiveLinkManagement from "./ObjectiveLinkManagement.vue";
import nxsAttendanceManagement from "./AttendanceManagement.vue";
import nxsEventEdit from "./EventEdit.vue";
import nxsEventScanning from "./EventScanning.vue";

export default {
    props: ["eventId"],
    components: {
        nxsObjectiveLinkManagement,
        nxsAttendanceManagement,
        nxsEventEdit,
        nxsEventScanning
    },
    data() {
        return {event: null};
    },
    computed: {...mapFields(["user", "terms"])},
    mounted() {
        if (this.eventId == null) {
            this.$router.push("/admin/eventsbytype");
        } else {
            this.pullEvent();
        }
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        eventSaved(event) {
            this.event = event;
        },
        pullEvent() {
            this.axios
                .get("/api/v1/events/" + this.eventId, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.event = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        openScanning() {
            this.$refs.scanningDialog.open();
        },
        openEdit() {
            this.$refs.editDialog.open();
        },
        openAttendance() {
            this.$refs.attendanceDialog.open();
        },
        openObjectives() {
            this.$refs.objectiveDialog.open();
        },
        closeDialog() {
            this.dialogVisible = false;
        }
    }
};
</script>
